import {Source} from "@common-core/coat-operational-hierarchy-appsync-model";

export const toCacmSource = (cacmId?: string): Source[] => {
  return cacmId
    ? [
        {
          sourceId: cacmId,
          sourceType: "CACM"
        }
      ]
    : [];
};
